import BaseAuth from '../baseAuth';
import { PICSART_API_BASE_URL } from '../constants';

class PicsartAuth extends BaseAuth {}

export default new PicsartAuth(PICSART_API_BASE_URL);
